import * as Yup from 'yup';

import { validateApprovalPassword } from 'utils/validation';

export const initialValues = {
  approvalPassword: '',
};

export const getValidationSchema = (isCredit?: boolean) =>
  Yup.object().shape({
    approvalPassword: isCredit ? validateApprovalPassword : Yup.number(),
  });
